import React from 'react';
import { Button, Table, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ThreeColumnTableRow from '../../Admin/CreateCourse/ThreeColumnTableRow';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class DetailsEng extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


    render() {
        const { implementation } = this.props;
        return (
            <div>
                <Table celled unstackable compact>
                    <Table.Header>
                        <Table.Row>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <ThreeColumnTableRow
                            name="Name"
                            keyName="name"
                            value={implementation.englishTranslation ? implementation.englishTranslation.name : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.name : ''}
                        />
                        <ThreeColumnTableRow
                            name="ECTS"
                            keyName="ects"
                            value={implementation.studyProgram.ects}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.ects}
                        />
                        <ThreeColumnTableRow
                            name="Duration year"
                            keyName="durationYear"
                            value={implementation.studyProgram.durationYear}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.durationYear}
                        />
                        <ThreeColumnTableRow
                            name="Duration semester"
                            keyName="durationSemester"
                            value={implementation.studyProgram.durationSemester}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.durationSemester}
                        />
                        <ThreeColumnTableRow
                            name="Academic year start"
                            keyName="academicYearStart"
                            value={implementation.studyProgram.academicYearStart ? implementation.studyProgram.academicYearStart.name : ''}
                            onChange={this.handleInputChange}
                            edit={this.state.edit}
                            academicYears={this.state.academicYears}
                            defValue={implementation.studyProgram.academicYearStart ? implementation.studyProgram.academicYearStart.name : ''}
                        />
                        <ThreeColumnTableRow
                            name="Study cycle"
                            keyName="studyCycle"
                            value={implementation.studyCycles ? implementation.studyCycles.map(el => (<div>{el.translations.find(e => e.language === 'en').displayName} <br /></div>)) : null}
                            onChange={this.handleInputChange}
                            edit={this.state.edit}
                            studyCycles={JSON.parse(localStorage.getItem('studyCycles'))}
                            defValue={implementation.studyCycles ? implementation.studyCycles.map(el => (<div>{el.translations.find(e => e.language === 'en').displayName} <br /></div>)) : null}
                        />
                        <ThreeColumnTableRow
                            name="Study program organizational units"
                            keyName="studyProgramOrganizationalUnits"
                            value={implementation.organizationalUnitDTOs.length ? implementation.organizationalUnitDTOs.map(el => (<div>{el.nameEnglish} <br /></div>)) : null}
                            onChange={this.handleInputChange}
                            edit={this.state.edit}
                            organizationalUnits={this.state.organizationalUnitDTOs}
                            defValue={implementation.organizationalUnitDTOs.length ? implementation.organizationalUnitDTOs.map(el => (<div>{el.nameEnglish} <br /></div>)) : null}
                        />
                        <ThreeColumnTableRow
                            name="Title name"
                            keyName="titleName"
                            value={implementation.studyProgramTitle.translations.length ? implementation.studyProgramTitle.translations.find(e => e.language === 'en').name : ''}
                            onChange={this.onChange}
                            disabled
                            edit={this.state.edit}
                            defValue={implementation.studyProgramTitle.translations.length ? implementation.studyProgramTitle.translations.find(e => e.language === 'en').name : ''}
                        />
                        {/* <ThreeColumnTableRow */}
                        {/*    name="Jezici" */}
                        {/*    keyName="languages" */}
                        {/*    value={implementation.englishTranslation  ? implementation.englishTranslation.languageIds ? implementation.englishTranslation.languageIds.map(el => (<div>{this.getLanguageName(el)} <br /></div>)) : null : ''} */}
                        {/*    onChange={this.handleInputChange} */}
                        {/*    edit={this.state.edit} */}
                        {/*    languages={this.state.allLanguages} */}
                        {/*    defValue={implementation.englishTranslation  ? implementation.englishTranslation.languageIds ? implementation.englishTranslation.languageIds[0] : null : ''} */}
                        {/* /> */}

                        <ThreeColumnTableRow
                            name="Description"
                            keyName="description"
                            value={implementation.englishTranslation ? implementation.englishTranslation.description : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.description : ''}
                        />
                        <ThreeColumnTableRow
                            name="Details"
                            keyName="details"
                            value={implementation.englishTranslation ? implementation.englishTranslation.details : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.details : ''}
                        />
                        <ThreeColumnTableRow
                            name="Classification of qualification"
                            keyName="classificationOfQualification"
                            value={implementation.englishTranslation ? implementation.englishTranslation.classificationOfQualification : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.classificationOfQualification : ''}
                        />
                        <ThreeColumnTableRow
                            name="Enrollment terms"
                            keyName="enrollmentTerms"
                            value={implementation.englishTranslation ? implementation.englishTranslation.enrollmentTerms : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.enrollmentTerms : ''}
                        />
                        <ThreeColumnTableRow
                            name="Study rules"
                            keyName="studyRules"
                            value={implementation.englishTranslation ? implementation.englishTranslation.studyRules : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.studyRules : ''}
                        />
                        <ThreeColumnTableRow
                            name="Grading scale"
                            keyName="gradingScale"
                            value={implementation.englishTranslation ? implementation.englishTranslation.gradingScale : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.gradingScale : ''}
                        />

                        <ThreeColumnTableRow
                            name="Next cycle enrollment possibility"
                            keyName="nextCycleEnrollmentPossibility"
                            value={implementation.englishTranslation ? implementation.englishTranslation.nextCycleEnrollmentPossibility : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.nextCycleEnrollmentPossibility : ''}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Professional status"
                            keyName="professionalStatus"
                            value={implementation.englishTranslation ? implementation.englishTranslation.professionalStatus : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.professionalStatus : ''}
                            textArea
                        />

                        <ThreeColumnTableRow
                            name="Study goals"
                            keyName="studyGoals"
                            value={implementation.englishTranslation ? implementation.englishTranslation.studyGoals : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.studyGoals : ''}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Study outcomes"
                            keyName="studyOutcomes"
                            value={implementation.englishTranslation ? implementation.englishTranslation.studyOutcomes : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.studyOutcomes : ''}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Additional information"
                            keyName="additionalInformation"
                            value={implementation.englishTranslation ? implementation.englishTranslation.additionalInformation : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.additionalInformation : ''}
                            textArea
                        />

                        <ThreeColumnTableRow
                            name="Additional information source"
                            keyName="additionalInformationSource"
                            value={implementation.englishTranslation ? implementation.englishTranslation.additionalInformationSource : ''}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.englishTranslation ? implementation.englishTranslation.additionalInformationSource : ''}
                            textArea
                        />

                    </Table.Body>
                </Table>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudyPrograms/DetailsEng.js